import type { Currency } from "@/lib/domain/Currency";
import type { PriceSource } from "@/lib/domain/PriceSource";
import { useHTTP, useHTTPMutation, type HTTPResponse } from "@/lib/http";
import { useQueryClient, type MutationFunction } from "@tanstack/react-query";

export interface ClonePublicCollectionResponseModel {
	readonly collectionId: string;
}

export const useClonePublicCollection = (shareToken: string, currency: Currency, priceSource: PriceSource) => {
	const http = useHTTP("Required");
	const queryClient = useQueryClient();

	const mutationFn: MutationFunction<HTTPResponse<ClonePublicCollectionResponseModel>, void> = () => {
		return http<ClonePublicCollectionResponseModel, undefined>({
			method: "POST",
			url: `/collection/public/${shareToken}/clone-public-collection?currency=${currency}&priceSource=${priceSource}`,
			body: undefined
		});
	};

	return useHTTPMutation({
		mutationFn,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["collections"] });
			queryClient.invalidateQueries({ queryKey: ["collectionsPerformanceDelta"] });
		}
	});
};
